import { NativeStackHeaderProps } from '@react-navigation/native-stack'
import { useNavigation } from 'expo-router'
import { useEffect } from 'react'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import { useUnistyles } from 'react-native-unistyles'

import BottomSheet, {
  renderBackdrop,
} from '@/components/navigation/BottomSheetLayout'
import FosterGridHeaderContent from '@/components/navigation/header/FosterGridHeaderContent'
import FosterHeader from '@/components/navigation/header/FosterHeader'
import useWidescreenBottomSheetStyle from '@/hooks/useWidescreenBottomSheetStyle'

export const unstable_settings = {
  initialRouteName: '(app)/(tabs)/',
}

const HeaderComponent = (props: NativeStackHeaderProps) => {
  return <FosterHeader {...props} />
}

const headerRight = () => <FosterGridHeaderContent />

const FosterRootLayout = () => {
  const { theme } = useUnistyles()
  const widescreenStyle = useWidescreenBottomSheetStyle()

  const navigation = useNavigation()

  useEffect(() => {
    navigation.setOptions({
      headerShown: true,
      header: HeaderComponent,
      headerRight,
    })
  }, [navigation])

  const screenOptions = {
    backdropComponent: renderBackdrop,
    backgroundStyle: {
      backgroundColor: theme.colors.surface,
    },
    contentStyle: { backgroundColor: theme.colors.background },
    enableDynamicSizing: true,
    freezeOnBlur: false,
    handleIndicatorStyle: {
      backgroundColor: theme.colors.onBackground,
    },
    handleStyle: {
      backgroundColor: theme.colors.surface,
    },
    style: widescreenStyle,
    android_keyboardInputMode: 'adjustPan' as const,
    keyboardBlurBehavior: 'restore' as const,
  }

  return (
    <GestureHandlerRootView>
      <BottomSheet screenOptions={screenOptions} />
    </GestureHandlerRootView>
  )
}

export default FosterRootLayout
